
      // Quick API debug tools
      window.addEventListener('load', () => {
        setTimeout(() => {
          // Load debug tools if needed
          if (window.location.hash === '#debug' || localStorage.getItem('debug_mode') === 'true') {
            const script = document.createElement('script');
            script.src = '/api-debug-tool.js';
            script.type = 'module';
            document.head.appendChild(script);
          }
        }, 2000);
      });
    